"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sha256 = void 0;
var sha2_1 = require("@ethersproject/sha2");
var strings_1 = require("@ethersproject/strings");
var Sha256 = /** @class */ (function () {
    function Sha256() {
    }
    Sha256.hash = function (value) {
        var bytes = (0, strings_1.toUtf8Bytes)(value);
        return (0, sha2_1.sha256)(bytes);
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
//# sourceMappingURL=Sha256.js.map